// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"nK-z","carouselContainer":"oK-z"};